import { UTILS__ml_asset } from '@/utils/UTILS__ml_asset';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { HOOK_TABLE_LAYOUT__inputs__base } from '../_base/HOOK_TABLE_LAYOUT__inputs__base';

interface PROPS {
  fields: FIELD_PRIMITIVE__string_hash_ml_asset[];
}

const helper_column = createColumnHelper<FIELD_PRIMITIVE__string_hash_ml_asset>();

export function HOOK_TABLE_LAYOUT__inputs__model({ fields }: PROPS) {
  /*
   *
   */

  const columns__additional = useMemo(
    () => [
      // Actions
      // helper_column.accessor(field => field, {
      //   id: 'actions',
      //   header: 'actions',
      //   cell: info => (
      //     <G_TABLE_CELL__inputs_images__buttons_base field={info.getValue()}>
      //       <></>
      //     </G_TABLE_CELL__inputs_images__buttons_base>
      //   ),
      // }),
      helper_column.accessor(row => row, { id: 'model_type', cell: info => render_cell_model_type(info.getValue()) }),
      helper_column.accessor(row => row, { id: 'items_amount', header: 'Value Range', cell: info => render_cell_models_range(info.getValue()) }),
      helper_column.accessor(row => row, {
        id: 'model_value',
        header: 'Value',
        cell: info => render_cell_model_name(info.getValue()),
      }),

      // Preview
    ],
    [],
  );

  /*
   *
   */

  /*
   *
   */

  function render_cell_model_type(field: FIELD_PRIMITIVE__string_hash_ml_asset) {
    let ml_asset = UTILS__ml_asset.get_by_hash(field.get_value());

    return <span className="font-mono">{ml_asset.type}</span>;
  }

  function render_cell_models_range(field: FIELD_PRIMITIVE__string_hash_ml_asset) {
    return <span className="font-mono">{`${field.get_value_range().length} items`}</span>;
  }
  function render_cell_model_name(field: FIELD_PRIMITIVE__string_hash_ml_asset) {
    let [name, version] = UTILS__ml_asset.get_name_and_version(field.get_value());

    return <span className="font-mono">{`${name} ${version}`}</span>;
  }

  return HOOK_TABLE_LAYOUT__inputs__base({ fields, columns__additional });
}
